import React, { useEffect, useState } from "react";
import styles from '../index.module.css';
import viewStyles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { editOrder, getOrderById } from "../../../../redux/features/orders/ordersService";
import { useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { addNewInvoice, changeInvoiceStatus, editInvoice, saveInvoiceDocument } from "../../../../redux/features/invoice/invoiceService";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import SimpleTableSkeleton from "../../../../components/SimpleTableSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleCheck, faMoneyBill, faPlusCircle, faUpload, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import PdfIcon from '../../../../assets/images/icons/pdf icon@3x.png';
import { editDocument } from "../../../../redux/features/document/documentService";
import Modal from "../../../../components/Modal";
import TableSkeleton from "../../../../components/Skeleton";
import InvoiceNew from "../../../../components/Receipts/InvoiceNew";
import { getBankAccounts } from "../../../../redux/features/bank/bankService";

const statusColors = {
    'Pending': '#FACC15',
    'Order Created': '#38BDF8',
    'Order Changed': '#14B8A6',
    'Order Confirmed': '#34D399',
    'Quotation Created': '#60A5FA',
    'Quotation Changed': '#22D3EE',
    'Quotation Sent': '#6366F1',
    'Order Cancelled': '#EF4444',
    'Order Refunded': '#FB7185',
    'Order Shipped': '#8B5CF6',
    'Order Completed': '#10B981',
};

const paymentStatusColors = {
    'Pending': '#FACC15',
    'Invoice Sent': '#38BDF8',
    'Order Changed': '#14B8A6',
    'Order Confirmed': '#34D399',
    'Quotation Created': '#60A5FA',
    'Quotation Changed': '#22D3EE',
    'Quotation Sent': '#6366F1',
    'Order Cancelled': '#EF4444',
    'Order Refunded': '#FB7185',
    'Order Shipped': '#8B5CF6',
    'Payment Approved': '#10B981',
};

const formattedAmount = (amount) =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);

const ViewOrder = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isInvoiceCreating } = useSelector((state) => state.invoice.newInvoice);
    const { isOrderLoading, order } = useSelector((state) => state.order.orderDetails);
    const { isEditingInvoice } = useSelector((state) => state.invoice.editedInvoice);
    const { isStatusLoading } = useSelector((state) => state.invoice.changeStatus);
    const { isBankAccountsLoading, bankAccounts } = useSelector((state) => state.bank.allBankAccounts);

    const [formData, setFormData] = useState({});

    const [errorMessages, setErrorMessages] = useState({});
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);
    const [billNumber, setBillNumber] = useState(null);
    const [bookingNumber, setBookingNumber] = useState(null);
    const [selectedBank, setSelectedBank] = useState(null);
    const [isNotifyParty, setNotifyParty] = useState(false);

    let cumulativeSellingPrice = 0;

    const getOrderData = async () => {
        try {
            const response = await dispatch(getOrderById({ id })).unwrap();
            if (response.status === 'Order Cancelled') {
                navigate('/admin/orders')
            }
            setFormData({
                bill_to_name: response?.bill_to_name,
                address_line_1: response?.address_line_1,
                address_line_2: response?.address_line_2,
                city: response?.city,
                details_line_1: response?.details_line_1,
                details_line_2: response?.details_line_2,
                details_line_3: response?.details_line_3,
            });
            setBillNumber(response?.bl_number);
            setBookingNumber(response?.booking_number);
        } catch (error) {
            showToast('error', error.message);
        }
    }

    useEffect(() => {
        getOrderData();
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(getBankAccounts({}));
    }, [dispatch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidQuotation = () => {
        const errors = {};
        if (!formData.address_line_1) {
            errors.address_line_1 = "Address line one is required.";
        }
        if (!formData.address_line_2) {
            errors.address_line_2 = "Address line two is required.";
        }
        if (!formData.city) {
            errors.city = "City is required.";
        }
        if (!formData.quotation_date) {
            errors.quotation_date = "Date is required.";
        }
        if (!formData.invoice_type) {
            errors.invoice_type = "Invoice Type is required.";
        }
        if (!formData.total_price_type) {
            errors.total_price_type = "Price type is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const data = {
        order_id: 1,
        bill_to_name: 'Nimal Perera',
        bill_to_address: 'No 12, Main Road',
        city: 'Colombo',
        details_line_1: 'Sri Lanka',
        quotation_date: '2025-05-24',
        valid_until: '2025-06-24',
        notes: '',
        quotation_status: "Quotation_Created"
    }

    const generateInvoice = async (data, invoice) => {
        try {
            const pdfBlob = await pdf(<InvoiceNew data={[data, order, selectedBank, invoice]} />).toBlob();
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, "_blank");
            dispatch(saveInvoiceDocument({invoice_document_file: pdfBlob, invoice_id:invoice.id}))
        } catch (error) {
            showToast('error', error.message);
        }
    }

    const submitQuotation = async () => {
        if (isValidQuotation()) {
            const data = {
                order_id: +id,
                bill_to_name: order?.customer.full_name,
                address_line_1: formData.address_line_1,
                address_line_2: formData.address_line_2,
                city: formData.city,
                details_line_1: formData.details_line_1,
                details_line_2: formData.details_line_2,
                details_line_3: formData.details_line_3,
                notify_name: formData.notify_name,
                notify_address_line_1: formData.notify_address_line_1,
                notifY_city: formData.notify_address_line_2,
                notify_country: formData.notify_country,
                invoice_date: formData.quotation_date,
                notes: formData.notes && formData.notes,
                shipping_marks: formData && formData.shipping_marks,
                total_price_type: formData.total_price_type,
                invoice_type: formData.invoice_type,
                bank_account_id: +formData.bank_account_id,
                shipment_type: formData.shipment_type && formData.shipment_type,
                incoterm: formData.incoterm && formData.incoterm,
                country: formData.country && formData.country,
                port_loading: formData.port_loading && formData.port_loading,
                port_unloading: formData.port_unloading && formData.port_unloading,
                destination: formData.destination && formData.destination,
                currency: formData.currency && formData.currency,
                shipment_date: formData.shipment_date && formData.shipment_date,
                lc_validity_period: formData.lc_validity_period && formData.lc_validity_period,
                transhipment: formData.transhipment && formData.transhipment,
                partial_shipment: formData.partial_shipment && formData.partial_shipment,
                is_notify: isNotifyParty,
                invoice_status: "Invoice Created"
            }
            try {
                const response = await dispatch(addNewInvoice(data)).unwrap();
                showToast('success', response.message);
                dispatch(getOrderById({ id }));
                await generateInvoice(data, response?.invoice);
            }
            catch (error) {
                showToast('error', error.message);
            };
        }
    }

    const updateQuotation = async () => {
        if (isValidQuotation()) {
            const invoiceData = {
                id: +order?.quotations[0].id,
                bill_to_name: order?.customer.full_name,
                address_line_1: formData.address_line_1,
                address_line_2: formData.address_line_2,
                city: formData.city,
                quotation_date: formData.quotation_date,
                valid_until: formData.valid_until,
                notes: formData.notes && formData.notes
            }
            const data = {
                id: +order?.quotations[0].id,
            }
            if (formData.address_line_1 !== order?.quotations[0].address_line_1) {
                data.address_line_1 = formData.address_line_1;
            }
            if (formData.address_line_2 !== order?.quotations[0].address_line_2) {
                data.address_line_2 = formData.address_line_2;
            }
            if (formData.city !== order?.quotations[0].city) {
                data.city = formData.city;
            }
            if (formData.quotation_date !== order?.quotations[0].quotation_date) {
                data.quotation_date = formData.quotation_date;
            }
            if (formData.valid_until !== order?.quotations[0].valid_until) {
                data.valid_until = formData.valid_until;
            }
            if (formData.notes !== order?.quotations[0].notes) {
                data.notes = formData.notes;
            }

            if (Object.keys(data).length === 1) {
                showToast('error', 'No updates were made as the quotation details remain unchanged.');
                return;
            }
            try {
                const response = await dispatch(editInvoice(data)).unwrap();
                showToast('success', response.message);
                dispatch(getOrderById({ id }));
                await generateInvoice(invoiceData);
            }
            catch (error) {
                showToast('error', error.message);
            };
        }
    }

    const updateQuotationStatus = async (quotation) => {
        try {
            const data = {
                id: +quotation.id,
                quotation_status: "Quotation Sent"
            }
            const response = await dispatch(changeInvoiceStatus(data)).unwrap();
            showToast('success', response.message);
            dispatch(getOrderById({ id }));
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const documentUpload = () => navigate(`/admin/orders/${id}/document`);

    const handleCancelYes = async () => {
        setCancelModalOpen(false);
        try {
            const data = {
                id: +selectedDocument.id,
                status: false
            }
            const response = await dispatch(editDocument(data)).unwrap();
            showToast('success', response.message);
            setSelectedDocument(null);
        }
        catch (error) {
            setSelectedDocument(null);
            showToast('error', error.message);
        };
    }

    const closeCancelModal = () => setCancelModalOpen(false);

    const viewDocument = (document) => {
        window.open(document.document_url, "_blank");
    }

    const openDocument = async (payment) => {
        window.open(payment.document_url, "_blank");
    }

    const viewInvoice = (document) => {
        window.open(document.invoice_document, "_blank");
    } 

    const viewPayment = (payment) => navigate(`/admin/orders/${id}/${payment.id}`);

    const submitBillNumber = async () => {
        try {
            const data = {
                id: +id,
                bl_number: billNumber
            }
            const response = await dispatch(editOrder(data)).unwrap();
            if (response.success === true) {
                showToast('success', response.message);
            }
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const submitBookingNumber = async () => {
        try {
            const data = {
                id: +id,
                booking_number: bookingNumber
            }
            const response = await dispatch(editOrder(data)).unwrap();
            if (response.success === true) {
                showToast('success', response.message);
            }
        } catch (error) {
            showToast('error', error.message);
        }
    }

    return (
        <div className={`card-section`}>
            <div className={`main-card`} style={{ minHeight: 'max-content', display: 'flex', flexDirection: 'column' }}>
                <h1 className={`form-title`}>Order Details</h1>
                <div className={styles.formContainer}>
                    <div className={viewStyles.orderDetailsDiv}>
                        <div className={viewStyles.customerDetails}>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Customer Code: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.customer_code}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Name: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.full_name}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Phone Number: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.phone_number}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Email: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.email}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Agent: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.agent.full_name}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Phone Number: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.agent.phone_number}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Order Status: </p>
                                <p className={`${viewStyles.valueSec} ${viewStyles.statusLabel}`} style={{ backgroundColor: statusColors[order?.status] }}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.status}</p>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Bill Number
                                        </label>
                                        {isOrderLoading ? <Skeleton inline width={100} /> :
                                            <div className={viewStyles.inputSingleRow}>
                                                <input
                                                    type="text"
                                                    id="bl_number"
                                                    name="bl_number"
                                                    value={billNumber || ''}
                                                    className={`form-input-default ${viewStyles.payInput}`}
                                                    placeholder="Enter number"
                                                    onChange={(e) => setBillNumber(e.target.value)} />
                                                <button type="button" className={viewStyles.checkBtn} onClick={submitBillNumber}><FontAwesomeIcon icon={faCheck} size="xl" /></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Booking Number
                                        </label>
                                        {isOrderLoading ? <Skeleton inline width={100} /> :
                                            <div className={viewStyles.inputSingleRow}>
                                                <input
                                                    type="text"
                                                    id="booking_number"
                                                    name="booking_number"
                                                    value={bookingNumber || ''}
                                                    className={`form-input-default ${viewStyles.payInput}`}
                                                    placeholder="Enter number"
                                                    onChange={(e) => setBookingNumber(e.target.value)} />
                                                <button type="button" className={viewStyles.checkBtn} onClick={submitBookingNumber}><FontAwesomeIcon icon={faCheck} size="xl" /></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={viewStyles.vehicleDetails}>
                            <label className={viewStyles.subTitle}>Vehicles</label>
                            <div className={`table-container`}>
                                {isOrderLoading ?
                                    <SimpleTableSkeleton columns={["Stock No", "Image", "Vehicle", "Year", "Chassis", "Lot NM", "Auction House", "Buying Price",
                                        "Auction Fee", "Local Transport", "EC Cost", "Repairing Cost", "FOB Cost", "Freight", "CNF Cost", "J and A Charge", "Selling Price", "Total"
                                    ]} rowCount={2} height={20} />
                                    :
                                    <table className={styles.table}>
                                        <thead className={styles.thead}>
                                            <tr>
                                                <th className={styles.theadD}>Stock No</th>
                                                <th className={styles.theadD}>Image</th>
                                                <th className={styles.theadD}>Vehicle</th>
                                                <th className={styles.theadD}>Year</th>
                                                <th className={styles.theadD}>Chassis</th>
                                                <th className={styles.theadD}>Lot NM</th>
                                                <th className={styles.theadD}>Auction House</th>
                                                <th className={styles.theadD}>Buying Price</th>
                                                <th className={styles.theadD}>Auction Fee</th>
                                                <th className={styles.theadD}>Local Transport</th>
                                                <th className={styles.theadD}>EC Cost</th>
                                                <th className={styles.theadD}>Repairing Cost</th>
                                                <th className={styles.theadD}>FOB Cost</th>
                                                <th className={styles.theadD}>Freight</th>
                                                <th className={styles.theadD}>CNF Cost</th>
                                                <th className={styles.theadD}>J and A Charge</th>
                                                <th className={styles.theadD}>Selling Price</th>
                                                <th className={styles.theadD}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody className={styles.tbody}>
                                            {order?.vehicles?.map((vehicle) => {
                                                const sellingPrice = vehicle.vehicle_costs[0]?.selling_price || 0;
                                                cumulativeSellingPrice += sellingPrice; // Add current selling_price to cumulative total

                                                return (
                                                    <tr key={vehicle.id}>
                                                        <td className={styles.tableCell}>{vehicle.stock_no}</td>
                                                        <td className={styles.tableCell}><img src={vehicle.image_url} alt="vehicle" className={viewStyles.vehicleImg} /></td>
                                                        <td className={styles.tableCell}>{vehicle.name}</td>
                                                        <td className={styles.tableCell}>{vehicle.reg_year}</td>
                                                        <td className={styles.tableCell}>{vehicle.chassis_no}</td>
                                                        <td className={styles.tableCell}>{vehicle.lot_nm}</td>
                                                        <td className={styles.tableCell}>{vehicle.auction_house}</td>

                                                        {/** Extract vehicle costs safely */}
                                                        {(() => {
                                                            const costs = vehicle.vehicle_costs[0] || {};
                                                            return (
                                                                <>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.buying_price)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.auction_fee)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.local_transport)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.ec_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.repairing_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.fob_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.freight)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.cnf_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.j_and_a_charge)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.selling_price)}</td>

                                                                    {/** Display Cumulative Selling Price */}
                                                                    <td className={styles.tableCellValue}><strong>{formattedAmount(cumulativeSellingPrice)}</strong></td>
                                                                </>
                                                            );
                                                        })()}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-group`}>
                                <label className={viewStyles.subTitle}>
                                    Documents
                                </label>
                                <div className={`drop-input-full`} style={{ minHeight: '0' }}>
                                    <div className={viewStyles.imagePreviewContainer}>
                                        {order?.order_documents
                                            ?.filter((doc) => doc.status === true)
                                            .map((doc) => (
                                                <div key={doc.id} className={viewStyles.insertedFile}>
                                                    <div className={viewStyles.fileCard}>
                                                        <img src={PdfIcon} alt='File Type' className={viewStyles.leftIcon} onClick={() => viewDocument(doc)} />
                                                        <FontAwesomeIcon
                                                            icon={faXmarkCircle}
                                                            className={viewStyles.closeIcon}
                                                            onClick={() => {
                                                                setSelectedDocument(doc);
                                                                setCancelModalOpen(true);
                                                            }}
                                                        />
                                                        <a
                                                            href={doc?.document_url}
                                                            className={viewStyles.fileDownload}
                                                            onClick={(e) => e.stopPropagation()}
                                                            target="blank"
                                                        >
                                                            {doc?.name}
                                                        </a>
                                                    </div>
                                                </div>
                                            ))}
                                        <div className={viewStyles.fileCard} onClick={documentUpload} >
                                            <FontAwesomeIcon icon={faPlusCircle} size="2xl" className={viewStyles.plusIcon} />
                                        </div>
                                    </div>
                                </div>
                                {errorMessages.file && (
                                    <p className={`text-danger`}>{errorMessages.file}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-group`}>
                                {order?.payments.length > 0 && <label className={viewStyles.subTitle} style={{ marginTop: '0' }}>
                                    Payments
                                </label>}
                                {isOrderLoading ?
                                    <>
                                        <label className={viewStyles.subTitle} style={{ marginTop: '0' }}>
                                            Payments
                                        </label>
                                        <TableSkeleton columns={["Date", "Amount", "Currency", "Exchange Rate", "Status", "Action"]} rowCount={10} height={20} />
                                    </>
                                    : order?.payments.length > 0 &&
                                    <div className={`table-container`}>
                                        <table className={`table`}>
                                            <thead className={`thead`}>
                                                <tr>
                                                    <th className={`theadColumnOne`}>Date</th>
                                                    <th>Amount</th>
                                                    <th>Currency</th>
                                                    <th>Exchange Rate</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className={`tbody`}>
                                                {order?.payments?.map((payment) => (
                                                    <tr key={payment.id}>
                                                        <td className={`tdataColumnOne`}>
                                                            {payment.created_at.split('T')[0]}
                                                        </td>
                                                        <td>{formattedAmount(payment.amount)}</td>
                                                        <td>{payment?.currency}</td>
                                                        <td>{payment?.exchange_rate}</td>
                                                        <td>
                                                            <p style={{ backgroundColor: paymentStatusColors[payment?.payment_status] }}
                                                                className={viewStyles.payemntStatusLabel}>{payment.payment_status}</p></td>
                                                        <td className={`actionsBtn`}>
                                                            {payment?.document_url !== '' &&
                                                                <button className={`btn-edit-label`} onClick={() => openDocument(payment)}>
                                                                    <FontAwesomeIcon icon={faMoneyBill} />
                                                                </button>
                                                            }
                                                            <button className={`btn-edit-label`} onClick={() => {
                                                                viewPayment(payment)
                                                            }}>View</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {/* Invoices */}
                      <div className={styles.vehicleFormGroup}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-group`}>
                                <label className={viewStyles.subTitle}>
                                    Invoices
                                </label>
                                <div className={`drop-input-full`} style={{ minHeight: '0' }}>
                                    <div className={viewStyles.imagePreviewContainer}>
                                        {order?.invoices
                                            ?.filter((doc) => doc?.invoice_documents[0]?.status === true)
                                            .map((doc) => (
                                                <div key={doc.id} className={viewStyles.insertedFile}>
                                                    <div className={viewStyles.fileCard}>
                                                        <img src={PdfIcon} alt='File Type' className={viewStyles.leftIcon} onClick={() => viewInvoice(doc?.invoice_documents[0])} />                                                      
                                                        <a
                                                            href={doc?.invoice_documents[0]?.invoice_document}
                                                            className={viewStyles.fileDownload}
                                                            onClick={(e) => e.stopPropagation()}
                                                            target="blank"
                                                        >
                                                            {doc?.invoice_documents[0]?.id}
                                                        </a>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <h1 className={`form-title`} style={{ marginTop: '20px' }}>Invoice</h1>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Billing Address Line 1<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='address_line_1'
                                            name='address_line_1'
                                            value={formData.address_line_1 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.address_line_1 && (
                                        <p className={`text-danger`}>{errorMessages.address_line_1}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Billing Address Line 2<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='address_line_2'
                                            name='address_line_2'
                                            value={formData.address_line_2 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.address_line_2 && (
                                        <p className={`text-danger`}>{errorMessages.address_line_2}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            City<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='city'
                                            name='city'
                                            value={formData.city || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.city && (
                                        <p className={`text-danger`}>{errorMessages.city}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 1
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_1'
                                            name='details_line_1'
                                            value={formData.details_line_1 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_1 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 2
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_2'
                                            name='details_line_2'
                                            value={formData.details_line_2 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_2 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_2}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 3
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_3'
                                            name='details_line_3'
                                            value={formData.details_line_3 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_3 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_3}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* Notify */}
                        <div className={`form-input-row ${viewStyles.radioRow}`} style={{ paddingBottom: '20px' }}>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                Is Notify Party Same as Consignee
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='notify' className={`form-label`}>
                                                <input type="radio" name="notify" value="yes" onChange={() => setNotifyParty(false)} className={viewStyles.customRadio} />
                                            </label>
                                            Yes
                                            <label htmlFor='notify' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="notify" value="no" onChange={() => setNotifyParty(true)} className={viewStyles.customRadio} />
                                            </label>
                                            No
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {isNotifyParty &&
                            <>
                                <p>Notify Party Details</p>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            {isOrderLoading ? <Skeleton /> :
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Notify Name<span className={`required-star`}>*</span>
                                                </label>
                                            }
                                            {isOrderLoading ? <Skeleton /> :
                                                <input
                                                    type='text'
                                                    id='notify_name'
                                                    name='notify_name'
                                                    value={formData.notify_name || ''}
                                                    onChange={handleInputChange}
                                                    className={`form-input-default`}
                                                    placeholder="Enter Address"
                                                />
                                            }
                                            {errorMessages.notify_name && (
                                                <p className={`text-danger`}>{errorMessages.notify_name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            {isOrderLoading ? <Skeleton /> :
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Notify Billing Address Line 1<span className={`required-star`}>*</span>
                                                </label>
                                            }
                                            {isOrderLoading ? <Skeleton /> :
                                                <input
                                                    type='text'
                                                    id='notify_address_line_1'
                                                    name='notify_address_line_1'
                                                    value={formData.notify_address_line_1 || ''}
                                                    onChange={handleInputChange}
                                                    className={`form-input-default`}
                                                    placeholder="Enter Address"
                                                />
                                            }
                                            {errorMessages.notify_address_line_1 && (
                                                <p className={`text-danger`}>{errorMessages.notify_address_line_1}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            {isOrderLoading ? <Skeleton /> :
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Notify City<span className={`required-star`}>*</span>
                                                </label>
                                            }
                                            {isOrderLoading ? <Skeleton /> :
                                                <input
                                                    type='text'
                                                    id='notify_address_line_2'
                                                    name='notify_address_line_2'
                                                    value={formData.notify_address_line_2 || ''}
                                                    onChange={handleInputChange}
                                                    className={`form-input-default`}
                                                    placeholder="Enter Address"
                                                />
                                            }
                                            {errorMessages.notifY_city && (
                                                <p className={`text-danger`}>{errorMessages.notifY_city}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            {isOrderLoading ? <Skeleton /> :
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Notify Country
                                                </label>
                                            }
                                            {isOrderLoading ? <Skeleton /> :
                                                <input
                                                    type='text'
                                                    id='notify_country'
                                                    name='notify_country'
                                                    value={formData.notify_country || ''}
                                                    onChange={handleInputChange}
                                                    className={`form-input-default`}
                                                    placeholder="Enter Country"
                                                />
                                            }
                                            {errorMessages.notify_country && (
                                                <p className={`text-danger`}>{errorMessages.notify_country}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Invoice Date<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='date'
                                            id='quotation_date'
                                            name='quotation_date'
                                            value={formData.quotation_date || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                        />
                                    }
                                    {errorMessages.quotation_date && (
                                        <p className={`text-danger`}>{errorMessages.quotation_date}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Shipment Type
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='shipment_type'
                                            name='shipment_type'
                                            value={formData.shipment_type || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Shipment Type"
                                        />
                                    }
                                    {errorMessages.shipment_type && (
                                        <p className={`text-danger`}>{errorMessages.shipment_type}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Incoterm
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='incoterm'
                                            name='incoterm'
                                            value={formData.incoterm || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Incoterm"
                                        />
                                    }
                                    {errorMessages.incoterm && (
                                        <p className={`text-danger`}>{errorMessages.incoterm}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Country
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='country'
                                            name='country'
                                            value={formData.country || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Country"
                                        />
                                    }
                                    {errorMessages.country && (
                                        <p className={`text-danger`}>{errorMessages.country}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Port of Loading
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='port_loading'
                                            name='port_loading'
                                            value={formData.port_loading || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Port of Loading"
                                        />
                                    }
                                    {errorMessages.port_loading && (
                                        <p className={`text-danger`}>{errorMessages.port_loading}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Port of Unloading
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='port_unloading'
                                            name='port_unloading'
                                            value={formData.port_unloading || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Port of Unoading"
                                        />
                                    }
                                    {errorMessages.port_unloading && (
                                        <p className={`text-danger`}>{errorMessages.port_unloading}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Final Destination
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='destination'
                                            name='destination'
                                            value={formData.destination || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Final Destination"
                                        />
                                    }
                                    {errorMessages.destination && (
                                        <p className={`text-danger`}>{errorMessages.destination}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Currency
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='currency'
                                            name='currency'
                                            value={formData.currency || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Currency"
                                        />
                                    }
                                    {errorMessages.currency && (
                                        <p className={`text-danger`}>{errorMessages.currency}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Payment Terms
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <textarea
                                            type='text'
                                            id='notes'
                                            name='notes'
                                            value={formData.notes || ''}
                                            onChange={handleInputChange}
                                            placeholder='Enter Payment Terms'
                                            className={`form-input-default`}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Shipping Marks
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <textarea
                                            type='text'
                                            id='shipping_marks'
                                            name='shipping_marks'
                                            value={formData.shipping_marks || ''}
                                            onChange={handleInputChange}
                                            placeholder='Enter Shipping Marks'
                                            className={`form-input-default`}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        {/* Terms */}
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Shipment Date
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='date'
                                            id='shipment_date'
                                            name='shipment_date'
                                            value={formData.shipment_date || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                        />
                                    }
                                    {errorMessages.shipment_date && (
                                        <p className={`text-danger`}>{errorMessages.shipment_date}</p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='lc_validity_period' className={`form-label`}>
                                                LC Validity Period in Days
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='lc_validity_period' className={`form-label`}>
                                                <input type="radio" name="lc_validity_period" value="30" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            30
                                            <label htmlFor='lc_validity_period' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="lc_validity_period" value="60" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            60
                                            <label htmlFor='lc_validity_period' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="lc_validity_period" value="90" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            90
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {errorMessages.lc_validity_period && (
                            <p className={`text-danger`} style={{ marginTop: '5px' }}>{errorMessages.lc_validity_period}</p>
                        )}
                        <div className={`form-input-row ${viewStyles.radioRow}`}>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                Transhipment
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='transhipment' className={`form-label`}>
                                                <input type="radio" name="transhipment" value="Allowed" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Allowed
                                            <label htmlFor='transhipment' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="transhipment" value="Not Allowed" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Not Allowed
                                        </div>
                                    </>
                                }
                            </div>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                Partial Shipment
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='partial_shipment' className={`form-label`}>
                                                <input type="radio" name="partial_shipment" value="Allowed" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Allowed
                                            <label htmlFor='partial_shipment' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="partial_shipment" value="Not Allowed" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Not Allowed
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {errorMessages.partial_shipment && (
                            <p className={`text-danger`} style={{ marginTop: '5px' }}>{errorMessages.partial_shipment}</p>
                        )}
                        <div className={`form-input-row ${viewStyles.radioRow}`}>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                Total Price Type
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                <input type="radio" name="total_price_type" value="CNF" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            CNF
                                            <label htmlFor='total_price_type' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="total_price_type" value="FOB" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            FOB
                                        </div>
                                    </>
                                }
                            </div>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='invoice_type' className={`form-label`}>
                                                Invoice Type
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='invoice_type' className={`form-label`}>
                                                <input type="radio" name="invoice_type" value="Performa" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Proforma
                                            <label htmlFor='invoice_type' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="invoice_type" value="Commercial" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Commercial
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className={`form-input-row ${viewStyles.radioRow}`}>
                            <div className={`form-input-col md-col`}>
                                {isBankAccountsLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='invoice_type' className={`form-label`}>
                                                Bank
                                            </label>
                                        </div>
                                        <div className={viewStyles.methodCards}>
                                            {bankAccounts?.map((account) => (
                                                <div key={account.id} className={viewStyles.methodCard}
                                                    onClick={() => { setFormData({ ...formData, bank_account_id: account.id }); setSelectedBank(account); }}
                                                    style={{
                                                        border: formData?.bank_account_id === account.id
                                                            ? '2px solid #E11F39'
                                                            : '2px solid #D1D5DB',
                                                        color: formData?.bank_account_id === account.id
                                                            ? 'white'
                                                            : 'black',
                                                    }}>
                                                    <img
                                                        src={account.image_url}
                                                        alt="BankAccount"
                                                        className={viewStyles.icon}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {errorMessages.invoice_type && (
                            <p className={`text-danger`} style={{ marginTop: '5px' }}>{errorMessages.invoice_type}</p>
                        )}
                        {
                            isOrderLoading ? <Skeleton /> :
                                <button
                                    className={`btn-primary`}
                                    type='button'
                                    disabled={isInvoiceCreating}
                                    onClick={submitQuotation}
                                    style={{ marginTop: '20px' }}
                                >
                                    {isInvoiceCreating ? <BeatLoader /> : `Create Invoice`}
                                </button>
                        }
                    </div>
                </div>
                <PDFViewer width="100%" height="800px" style={{ marginTop: '20px' }}>
                    <InvoiceNew data={[formData, order, selectedBank]} />
                </PDFViewer>
            </div>
            {isCancelModalOpen && (
                <Modal
                    title='Remove Document'
                    onClose={closeCancelModal}
                    onYes={handleCancelYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to remove the document?`}
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};

export default ViewOrder;
